import previews from "./previews.json";

// The small picture of a widget type in the widget picker (VisionPlatform device-dashboards DDB-38). previews.json is
// a copy of VisionPlatform brand/widget-previews/previews.json: change it there first and copy it here. One colour,
// drawn in the text colour around it; a type without a picture (a newer catalogue) shows the empty frame.
type Style = { stroke?: number; fill?: boolean; opacity: number };
const STYLES: Record<string, Style> = previews.styles;
const PARTS: Record<string, string[][]> = previews.previews;
const [W, H] = previews.viewBox;

export function hasPreview(type: string): boolean {
  return type in PARTS;
}

function Part({ style, d }: { style: Style | undefined; d: string }) {
  if (!style) return null;
  return style.fill ? (
    <path d={d} fill="currentColor" fillOpacity={style.opacity} />
  ) : (
    <path
      d={d}
      fill="none"
      stroke="currentColor"
      strokeWidth={style.stroke}
      strokeOpacity={style.opacity}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  );
}

export function WidgetPreview({ type, className = "h-8 w-12" }: { type: string; className?: string }) {
  return (
    <svg viewBox={`0 0 ${W} ${H}`} aria-hidden="true" focusable="false" data-preview={type} className={className}>
      <Part style={STYLES.frame} d={previews.frame} />
      {(PARTS[type] ?? []).map(([style = "", d = ""], i) => (
        <Part key={i} style={STYLES[style]} d={d} />
      ))}
    </svg>
  );
}
